import { create } from 'zustand';

interface ObjectImagesState {
  /** objectId -> imageId des aktuell hinterlegten Bildes. */
  images: Record<string, string>;
  setAll: (images: Record<string, string>) => void;
  setImage: (objectId: string, imageId: string) => void;
  reset: () => void;
}

/** Aktuelle Bilder der 'picture'-Objekte (Snapshot + object:image-Event). */
export const useObjectImagesStore = create<ObjectImagesState>((set) => ({
  images: {},
  setAll: (images) => set({ images }),
  setImage: (objectId, imageId) =>
    set((state) => ({ images: { ...state.images, [objectId]: imageId } })),
  reset: () => set({ images: {} }),
}));
